export default __webpack_public_path__ + "static/media/logo.6dd35d72.png";